export default {
  itemsPerformance: {
    title: 'Item Performance',
    correct: 'Correct',
    partially_correct: 'Partially correct',
    incorrect: 'Incorrect',
    not_scored: 'Not scored',
    ratingTitle: 'Item Analysis',
    matrixTitle: 'Matrix Analysis',
    itemBubbleAriaLabel: 'Item {{itemNumber}}, {{status}}, {{numOfItem}} of {{totalItems}}',
    questionAriaLabel: 'Question'
  }
};